import { Input } from "antd"
import { InputProps } from "antd/lib/input"
import React, { useRef } from "react"
import cx from "classnames"
import styles from "./style.module.css"
import { isAldeia } from "hooks/useAldeia"

interface ISearchInputProps extends InputProps {
  // ref?: any
  gray?: boolean
  icon?: boolean
  autoFocus?: boolean
}

function SearchInput(props: ISearchInputProps) {
  const { gray, icon, ...rest } = props
  const searchRef = useRef<any>(null)

  // useEffect(() => {
  //     if (props.autoFocus) {
  //         setTimeout(() => {
  //             ``searchRef?.current?.focus()
  //         }, 500)
  //     }
  // }, [searchRef, props.autoFocus])

  return (
    <Input
      autoComplete="off"
      key={"search-input"}
      // prefix={<i className="far fa-search" />}
      {...rest}
      placeholder={rest.placeholder || "Pesquisar"}
      className={cx(
        styles.search,
        "g_input_search",
        {
          [styles.gray]: gray,
          [styles.small]: props.size == "small",
        },
        props.className,
      )}
      id="search-input"
      // allowClear={{ clearIcon: <i className="fal fa-times" /> } as any}
      allowClear
      autoFocus={props.autoFocus}
      ref={searchRef as any}
      prefix={
        icon ? (
          isAldeia ? (
            <IconMageSearch className="size-5 mr-2 ml-1 text-content-200" />
          ) : (
            <i className="far fa-search" style={{ marginRight: 3, marginLeft: 3 }} />
          )
        ) : undefined
      }
    />
  )
}

export default SearchInput
